import css from './createAlarmSituationSidePage.module.css'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import SidePage from '@/shared/SidePage'
import Button from '@/shared/Buttons/Button'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { TCreateAlarmSituationDTO } from '../../alarmSituations.types.ts'
import alarmSituationApi from '../../alarmSituations.api.ts'
import alarmSituationsEvents from '../../events/alarmSituations.events.ts'
import alarmSituationUtils from '../../alarmSituations.utils.ts'
import AlarmSituationFormFields from '../AlarmSituationFormFields'
import alarmSituationGenerators from '../../alarmSituation.generators.ts'

interface IProps {
  open: boolean
  onClose: () => void
}

const CreateAlarmSituationSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [alarmSituation, _, handleChange] = useStateWithChange<TCreateAlarmSituationDTO>(
    alarmSituationGenerators.generateCreateParameterDTO()
  )

  const handleCreateParameter = () => {
    wait(alarmSituationApi.createAlarmSituation(alarmSituation), (resp) => {
      if (resp.status === 'success') {
        alarmSituationsEvents.created(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} key="createParameterSidePage">
      <div className="flex-lines gap16" style={{ height: '100%' }}>
        <h4 className="text-heading-4">Создание триггера сигнальной ситуации</h4>
        <SeparateLine />
        <div className={css.wrapperContent}>
          <AlarmSituationFormFields alarmSituation={alarmSituation} handleChange={handleChange} />
          <div className={css.actions}>
            <Button
              size="default"
              type="primary"
              text="Создать"
              onClick={handleCreateParameter}
              disabled={!alarmSituationUtils.isCorrectFormAlarmSituationFields(alarmSituation)}
              loading={loading}
            />
            <Button size="default" type="default" text="Отменить" onClick={props.onClose} disabled={loading} />
          </div>
        </div>
      </div>
    </SidePage>
  )
}

export default CreateAlarmSituationSidePage
